import React from 'react';
import {
  PROGRAM_PROGRESS_SAVED_EVENT,
  type ProgramProgressSavedDetail,
} from '../utils/programProgressSavedEvents';

/** 대시보드·연간진도 등 외부 저장 후 keep-alive 프로그램 페이지가 LS/메모리를 다시 맞추게 함 */
export function useProgramProgressSavedRefresh(params: {
  workspaceId: string;
  gradeId: string;
  academicYear: number;
  termNumber: 1 | 2 | null;
  onRefresh: () => void;
}): void {
  const { workspaceId, gradeId, academicYear, termNumber, onRefresh } = params;
  const onRefreshRef = React.useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  React.useEffect(() => {
    if (!workspaceId || !gradeId || !termNumber) return undefined;
    const onProgramSaved = (e: Event) => {
      const d = (e as CustomEvent<ProgramProgressSavedDetail>).detail;
      if (!d?.workspaceId || !d.gradeId) return;
      if (d.workspaceId !== workspaceId || d.gradeId !== gradeId) return;
      if (d.academicYear !== academicYear || d.termNumber !== termNumber) return;
      /** cache 모드는 전량 재조회 없이 캐시만 맞춘 상태 — keep-alive 페이지도 remount/refetch 생략 */
      if ((d.uiRefreshMode ?? 'full') === 'cache') return;
      onRefreshRef.current();
    };
    window.addEventListener(PROGRAM_PROGRESS_SAVED_EVENT, onProgramSaved as EventListener);
    return () => {
      window.removeEventListener(PROGRAM_PROGRESS_SAVED_EVENT, onProgramSaved as EventListener);
    };
  }, [academicYear, gradeId, termNumber, workspaceId]);
}
